"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.setRowIndexToBeUnlinked = exports.setComponentToBeUnlinked = exports.deleteAssociationError = exports.deleteAssociationSuccess = exports.deleteAssociation = exports.closeDeleteAssociationModal = exports.openDeleteAssociationModal = exports.associateProductToComponentsError = exports.associateProductToComponentsSuccess = exports.associateProductToComponents = exports.resetAssociatedComponentsList = exports.getAssociatedComponentsListError = exports.getAssociatedComponentsListSuccess = exports.getAssociatedComponentsList = exports.associatedComponentsSlice = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const initialState = {
    associatedComponents: [],
    isAssociatedComponentsListLoading: false,
    hasErrorLoadingAssociatedComponents: false,
    isCreatingAssociation: false,
    hasErrorCreatingAssociation: false,
    createAssociationSuccess: false,
    isDeleteAssociationModalOpen: false,
    isDeletingAssociation: false,
    deleteAssociationSuccess: false,
    deleteAssociationError: false,
    componentToBeUnlinked: null,
    rowIndexToBeUnlinked: 0
};
exports.associatedComponentsSlice = (0, toolkit_1.createSlice)({
    name: "associatedComponents",
    initialState,
    reducers: {
        getAssociatedComponentsList: (state) => {
            state.isAssociatedComponentsListLoading = true;
        },
        getAssociatedComponentsListSuccess: (state, action) => {
            state.isAssociatedComponentsListLoading = false;
            state.hasErrorLoadingAssociatedComponents = false;
            state.associatedComponents = action.payload;
        },
        getAssociatedComponentsListError: (state) => {
            state.isAssociatedComponentsListLoading = false;
            state.hasErrorLoadingAssociatedComponents = true;
        },
        resetAssociatedComponentsList: (state) => {
            state.associatedComponents = [];
        },
        associateProductToComponents: (state) => {
            state.isCreatingAssociation = true;
            state.hasErrorCreatingAssociation = false;
            state.createAssociationSuccess = false;
        },
        associateProductToComponentsSuccess: (state) => {
            state.isCreatingAssociation = false;
            state.hasErrorCreatingAssociation = false;
            state.createAssociationSuccess = true;
        },
        associateProductToComponentsError: (state) => {
            state.isCreatingAssociation = false;
            state.hasErrorCreatingAssociation = true;
            state.createAssociationSuccess = false;
        },
        openDeleteAssociationModal: (state) => {
            state.isDeleteAssociationModalOpen = true;
        },
        closeDeleteAssociationModal: (state) => {
            state.isDeleteAssociationModalOpen = false;
        },
        deleteAssociation: (state) => {
            state.isDeletingAssociation = true;
            state.deleteAssociationError = false;
            state.deleteAssociationSuccess = false;
        },
        deleteAssociationSuccess: (state) => {
            state.isDeletingAssociation = false;
            state.deleteAssociationError = false;
            state.deleteAssociationSuccess = true;
        },
        deleteAssociationError: (state) => {
            state.isDeletingAssociation = false;
            state.deleteAssociationError = true;
            state.deleteAssociationSuccess = false;
        },
        setComponentToBeUnlinked: (state, action) => {
            state.componentToBeUnlinked = action.payload;
        },
        setRowIndexToBeUnlinked: (state, action) => {
            state.rowIndexToBeUnlinked = action.payload;
        }
    },
});
_a = exports.associatedComponentsSlice.actions, exports.getAssociatedComponentsList = _a.getAssociatedComponentsList, exports.getAssociatedComponentsListSuccess = _a.getAssociatedComponentsListSuccess, exports.getAssociatedComponentsListError = _a.getAssociatedComponentsListError, exports.resetAssociatedComponentsList = _a.resetAssociatedComponentsList, exports.associateProductToComponents = _a.associateProductToComponents, exports.associateProductToComponentsSuccess = _a.associateProductToComponentsSuccess, exports.associateProductToComponentsError = _a.associateProductToComponentsError, exports.openDeleteAssociationModal = _a.openDeleteAssociationModal, exports.closeDeleteAssociationModal = _a.closeDeleteAssociationModal, exports.deleteAssociation = _a.deleteAssociation, exports.deleteAssociationSuccess = _a.deleteAssociationSuccess, exports.deleteAssociationError = _a.deleteAssociationError, exports.setComponentToBeUnlinked = _a.setComponentToBeUnlinked, exports.setRowIndexToBeUnlinked = _a.setRowIndexToBeUnlinked;
exports.default = exports.associatedComponentsSlice.reducer;
